const rows = Array.from({ length: 5 });

export function MessageTemplatesTableSkeleton() {
  return (
    <div className="overflow-hidden rounded-xl border border-beige-200 bg-white">
      <table className="min-w-full text-left text-sm">
        <thead className="bg-cream-50">
          <tr>
            <th className="px-4 py-3">Name</th>
            <th className="px-4 py-3">Status</th>
            <th className="px-4 py-3">Updated</th>
            <th className="px-4 py-3">Preview</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-beige-100">
          {rows.map((_, index) => (
            <tr key={index} className="animate-pulse">
              <td className="px-4 py-3">
                <div className="h-4 w-40 rounded bg-beige-200" />
              </td>
              <td className="px-4 py-3">
                <div className="h-4 w-16 rounded bg-beige-200" />
              </td>
              <td className="px-4 py-3">
                <div className="h-4 w-24 rounded bg-beige-200" />
              </td>
              <td className="px-4 py-3">
                <div className="h-4 w-56 rounded bg-beige-200" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default MessageTemplatesTableSkeleton;
